<script>

import {Head, Link} from '@inertiajs/vue3';
import BreezeGuestLayout from "@/Layouts/Guest.vue";

export default {
    layout: BreezeGuestLayout,

    props: {
        errorMessage: {
            type: String,
            default: '',
        },

        errorCode: {
            type: Number,
            default: '',
        },

        goBackUrl: {
            type: String,
            default: '/login',
        },

    },

    components: {
        Head,
        Link,
    },
}
</script>

<template>
    <Head title="Application Error" />

    <div class="py-12">
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">

            <div>
                <div class="font-large text-red-600">
                    {{ errorCode }}: {{ errorMessage }}
                </div>
                <div class="font-large p-10">
                    <a :href="goBackUrl" class="btn btn-dark btn btn-dark flex items-center justify-center">Go back</a>
                    <a href="/login" class="btn btn-dark btn btn-dark flex items-center justify-center mt-5">Go to login page</a>
                </div>
            </div>
        </div>
    </div>

</template>
